export default "<p>games works!</p>\r\n";